import React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const iconBoxVariants = cva(
  'rounded-md bg-gray-100 border border-gray-200 flex items-center justify-center',
  {
    variants: {
      size: {
        sm: 'w-6 h-6',
        md: 'w-8 h-8',
        lg: 'w-12 h-12',
      },
    },
    defaultVariants: {
      size: 'lg',
    },
  }
)

interface Props extends VariantProps<typeof iconBoxVariants> {
  children: React.ReactNode
  className?: string
}

function IconBox({ size, children, className }: Props) {
  return (
    <div className={cn(iconBoxVariants({ size, className }))}>{children}</div>
  )
}

export default IconBox
